import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { generateInvoice, getFinancialYear } from '@/api/orders-dispatches';
import { downloadCSV, downloadExcelNewItemWise, getAllData, getNewItemWiseReport } from '@/api/orders-products-dispatches';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery } from '@/utils/index';
import Inr from '@/components/Inr/index.vue';
import DealerDetails from './components/DealerDetails.vue';
import { searchDealers } from '@/api/dealers';
import { AdminModule } from '@/store/modules/admin';
import { getStates } from '@/api/locations/states';
import { getCities } from '@/api/locations/cities';
import Enabled from '@/components/Enabled/index.vue';
import { searchProducts } from '@/api/products';
import { getAgents } from '@/api/agents';
import { getRanges } from '@/api/ranges';
import { getCategories } from '@/api/categories';
import { getBranches } from '@/api/locations/branches';
import { BranchAgentService } from '@/services/branch-agent-service';
import { cleanListQuery, isAdmin, isSuperAdmin } from '@/common';
import moment from 'moment';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.baseUrl = process.env.VUE_APP_BASE_API;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = false;
    this.downloadLoading = false;
    this.dateRange = '';
    this.dialogVisible = false;
    this.isAgent = false;
    this.dispatchId = 0;
    this.unitManagers = [];
    this.unitList = [];
    this.dealerList = [];
    this.agentList = [];
    this.branchListLoading = false;
    this.branchList = [];
    this.stateList = [];
    this.cityList = [];
    this.rangeList = [];
    this.categoryList = [];
    this.subCategoryList = [];
    this.categoryId = null;
    this.subCategoryId = null;
    this.products = [];
    this.selectedVariationId = null;
    this.dealerListLoading = false;
    this.stateListLoading = false;
    this.cityListLoading = false;
    this.productListLoading = false;
    this.selectedProduct = null;
    this.assignedBranches = [] || null;
    this.statusOptions = ['Pending', 'Request Approval', 'Approved', 'Rejected'];
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
    this.statusColorMap = {
      Pending: 'warning',
      'Request Approval': 'primary',
      Approved: 'success',
      Rejected: 'danger'
    };
    this.showFilters = false;
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: undefined,
      selectedVariationId: undefined,
      adminId: undefined,
      agentId: undefined,
      productId: undefined,
      productName: undefined,
      categoryId: undefined,
      subCategoryId: undefined,
      productVariationId: undefined,
      cityId: undefined,
      stateId: undefined,
      status: 'Approved',
      startDate: undefined,
      endDate: undefined,
      applyBranchIdFilter: true,
      branchId: undefined,
      excludeBranches: false,
      sort: 'id,ASC'
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.loggedInAdmin = null;
  }
  onCheckboxChange(value) {
    this.listQuery.excludeBranches = value;
  }
  _isAdminRoles() {
    return isSuperAdmin() || isAdmin();
  }
  async activated() {
    // if (!this._isAdminRoles()) {
    this.listQuery.excludeBranches = true;
    // }
    this.loggedInAdmin = AdminModule;
    // this.listQuery.branchId = await BranchAgentService.assignBranchId();
    this.assignedBranches = await BranchAgentService.assignBranchId();
    // Check if branchId is null and throw an error
    if (this.assignedBranches === null) {
      throw new Error('You are not assigned to a branch.');
    }
    // Fetch agents for the assigned branchId
    this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
    // Fetch branches for non-super admin users
    this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
    // check if logged in user is Agent/Admin
    if (this.loggedInAdmin.userType === 'Agent') {
      this.isAgent = true;
      this.listQuery.agentId = this.loggedInAdmin.agentId;
    }
    if (!this.dateRange) {
      this.getCurrentFinancialYear();
    }
    this.listQuery = {
      ...this.listQuery,
      ...this.$route.query
    };
    // get dispatch list
    this.getList();
    // this.fetchAgentList();
    // this.fetchBranches();
    this.fetchRanges();
    this.getStateList();
  }
  async getList() {
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      if (this.dateRange) {
        this.listQuery.startDate = this.dateRange.start;
        this.listQuery.endDate = this.dateRange.end;
      }
      this.listQuery.categoryId = undefined;
      if (this.categoryId) {
        this.listQuery.categoryId = this.categoryId;
      }
      if (this.subCategoryId) {
        this.listQuery.subCategoryId = this.subCategoryId;
      }
      const data = await getNewItemWiseReport(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async fetchBranches() {
    this.branchListLoading = true;
    this.branchList = await getBranches(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
    this.branchListLoading = false;
  }
  async getCurrentFinancialYear() {
    const dateData = await getFinancialYear();
    this.dateRange = {
      start: dateData.startDate,
      end: dateData.endDate
    };
    this.listQuery.startDate = this.dateRange.start;
    this.listQuery.endDate - this.dateRange.end;
    this.getList();
  }
  async getListWithoutPagination() {
    const queryWithoutPagination = {
      ...this.listQuery
    };
    delete queryWithoutPagination.page;
    delete queryWithoutPagination.limit;
    const data = await getAllData(getQuery(queryWithoutPagination));
    return data;
  }
  formatDiscount(value) {
    return value === null ? 0 : value;
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async fetchAgentList() {
    try {
      this.agentList = await getAgents(getQuery({
        enable: true,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq'
        }
      }));
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async getStateList(query = null) {
    try {
      this.stateList = await getStates(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getCityList(stateId = 0) {
    try {
      this.cityListLoading = true;
      this.cityList = await getCities(getQuery({
        enabled: true,
        stateId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          stateId: '$eq'
        }
      }));
      this.cityListLoading = false;
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getProductList(query) {
    try {
      this.productListLoading = true;
      if (query && query.length > 2) {
        this.products = await searchProducts(getQuery({
          keyword: query
        }));
      }
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      throw err;
    }
  }
  handleCategoryFilter() {
    this.categoryId = undefined;
    this.subCategoryId = undefined;
    this.fetchCategories();
    this.getList();
  }
  handleSubCategoryFilter() {
    this.subCategoryId = undefined;
    if (this.categoryId) {
      this.fetchSubCategories();
    } else {
      this.categoryId = undefined;
    }
    this.getList();
  }
  async fetchRanges() {
    this.rangeList = await getRanges(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchCategories() {
    if (this.listQuery.rangeId) {
      this.categoryList = await getCategories(getQuery({
        enabled: true,
        parentId: true,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$isnull',
          rangeId: '$in'
        }
      }));
      if (this.categoryList.length === 0) {
        this.categoryId = undefined;
      }
    } else {
      this.categoryList = [];
    }
  }
  async fetchSubCategories() {
    if (this.categoryId) {
      this.subCategoryList = await getCategories(getQuery({
        enabled: true,
        parentId: this.categoryId,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$eq',
          rangeId: '$eq'
        }
      }));
      if (this.subCategoryList.length === 0) {
        this.subCategoryId = undefined;
      }
    } else {
      this.subCategoryList = [];
    }
  }
  handleProductSelection(value) {
    if (value) {
      if (value.startsWith('product-')) {
        this.listQuery.productId = +value.replace('product-', '');
        this.listQuery.productVariationId = undefined;
      } else if (value.startsWith('variation-')) {
        this.listQuery.productId = undefined;
        this.listQuery.productVariationId = +value.replace('variation-', '');
      }
    } else {
      // Clear the product filters when value is null or empty
      this.listQuery.productId = undefined;
      this.listQuery.productVariationId = undefined;
    }
    this.handleFilter();
  }
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.listQuery.stateId) {
      this.getCityList(this.listQuery.stateId);
    } else {
      // empty city
      this.cityList = [];
      this.listQuery.cityId = undefined;
      this.listQuery.stateId = undefined;
    }
    if (!this.listQuery.cityId) {
      this.listQuery.cityId = undefined;
    }
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    } else {
      this.listQuery.startDate = undefined;
      this.listQuery.endDate = undefined;
    }
    this.listQuery.page = 1;
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      // this.listQuery.excludeBranches = true;
      // Fetch the list after agents and branches are loaded
      this.getList();
    } else {
      // await this.handleClearBranch();
      this.getList();
    }
  }
  toggleExpand(row) {
    const eltable = this.$refs.eltable;
    eltable.toggleRowExpansion(row);
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  toggleDialog(id = 0) {
    this.dialogVisible = true;
    this.dispatchId = id;
  }
  async downloadInvoice(id = 0) {
    // get invoice url
    this.listLoading = true;
    const url = await generateInvoice(id);
    if (url) {
      window.open(url, '_blank');
      // const filename = "invoice_" + id + ".pdf";
      // this.downloadFile(data.url, filename);
    } else {
      this.$message({
        message: 'Failed to generate invoice',
        type: 'error'
      });
    }
    this.listLoading = false;
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    this.listQuery = cleanListQuery(this.listQuery);
    try {
      const query = this.listQuery;
      let startDate = '';
      let endDate = '';
      if (this.listQuery.startDate && this.listQuery.endDate) {
        startDate = this.listQuery.startDate;
        endDate = this.listQuery.endDate;
      }
      // let datas: any = await this.getListWithoutPagination();
      // let data = datas.data;
      const blob = await downloadExcelNewItemWise({
        query,
        startDate,
        endDate,
        applyBranchIdFilter: true
      });
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'item-wise-report.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
  getVisibleColumns() {
    const table = this.$refs.table;
    const visibleColumns = table.columns.filter(column => !column.hidden);
    return visibleColumns;
  }
  async handleCSVDownload() {
    this.downloadLoading = true;
    try {
      // Call the downloadCSV function to get the Blob object
      const blob = await downloadCSV(this.list);
      // Create URL for the Blob
      const url = window.URL.createObjectURL(blob);
      // Create download link
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'item-wise-report.csv');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading CSV:', error);
      this.$message.error('Error downloading CSV');
    } finally {
      this.downloadLoading = false;
    }
  }
  getSummaries(param) {
    const {
      columns,
      data
    } = param;
    const sums = [];
    columns.forEach((column, index) => {
      // first column
      if (index === 0) {
        sums[index] = 'Total';
        return;
      }
      // Grand Total column
      if (index === 3) {
        // get all values
        const values = data.map(item => Number(item[column.property]));
        // loop over & null check
        if (!values.every(value => isNaN(value))) {
          // sum  them using reduce
          sums[index] = values.reduce((prev, curr) => {
            // value conversion (do check with Sandesh if toFixed something else required for decimal precision)
            const value = Number(curr);
            // null check
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0); // initial value
        } // loop if ends
      } // index check ends
    }); // columm loop ends
    // return sums
    if (sums && sums.length) {
      sums[3] = sums[3].toFixed(2);
    }
    return sums;
  }
};
default_1 = __decorate([Component({
  name: 'NewItemWiseReport',
  components: {
    Pagination,
    Inr,
    Enabled,
    DealerDetails
  }
})], default_1);
export default default_1;